import {
    UPDATE_STUDENT_USER_INFO,
} from '../../actionTypes';

export const updateStudentUserInfo = (json) => {
    return {
        type: UPDATE_STUDENT_USER_INFO,
        payload: json
    };
}